import React from 'react';

import { useGetBasicUomEnum } from 'hooks';

import SeparatorBar from '../../nutrition-label/components/SeparatorBar';
import NutrientSideBySide from '../../nutrition-label/components/NutrientSideBySide';

import { getUomTypesAbbreviations } from '../../nutrition-label/DailyValueConstants';
import NutrientRowNew from '../../nutrition-label/components/NutrientRowNew';
import { Col, Row } from 'antd';
import { WrapperFactsPanel } from './overlay/WrapperNutrient';

function VerticalLabelWithMicronutrient({ label, nutrients, compareValue }) {
  const { basicUomProperties } = useGetBasicUomEnum();

  return (
    <div className='nutrition-facts scroller'>
      <h1 className='nutrition-facts__label'>Nutrition Facts</h1>
      <SeparatorBar />
      <div className='nutrition-facts__servingsize'>
        {Boolean(label?.servingsPerContainer) && (
          <WrapperFactsPanel
            label={['servingsPerContainer']}
            currentValue={label}
            originValue={compareValue}
          >
            <div className='nutrition-facts__servings-per-container'>
              {label?.servingsPerContainer} serving per container
            </div>
          </WrapperFactsPanel>
        )}
        <WrapperFactsPanel
          label={[
            'servingSizeDescription',
            'servingSize',
            'servingSizeMeasurement',
          ]}
          currentValue={label}
          originValue={compareValue}
        >
          <div className='nutrition-facts__servingsize-bold'>
            <div>Serving size</div>
            <div>
              {label?.servingSizeDescription}{' '}
              {label?.servingSize &&
                `(${label?.servingSize} ${getUomTypesAbbreviations(
                  basicUomProperties,
                  label?.servingSizeMeasurement
                )})`}
            </div>
          </div>
        </WrapperFactsPanel>
      </div>
      <SeparatorBar height={7} />
      <WrapperFactsPanel
        label={['calories']}
        currentValue={label}
        originValue={compareValue}
      >
        <div className='nutrition-facts__calories-container'>
          <div>
            <div className='nutrition-facts__calories'>Amount Per Serving</div>
            <div className='nutrition-facts__calories_new-calories'>
              Calories
            </div>
          </div>

          <div className='nutrition-facts__calories_numeric'>
            {label?.calories}
          </div>
        </div>
      </WrapperFactsPanel>
      <SeparatorBar height={3} />
      <div className='nutrition-facts__dv-heading'>% Daily Value*</div>
      <Row>
        {nutrients?.map((nutrient, index) => {
          const { isStepByStep } = nutrient;
          return (
            <Col span={isStepByStep ? 12 : 24} key={index}>
              {isStepByStep ? (
                <NutrientSideBySide index={index} nutrient={nutrient} />
              ) : (
                <NutrientRowNew nutrient={nutrient} />
              )}
            </Col>
          );
        })}
      </Row>
      <SeparatorBar height={3} />
      <WrapperFactsPanel
        label={['fdaLabelFootNote']}
        currentValue={label}
        originValue={compareValue}
      >
        <div className='nutrition-facts__footnote'>
          <span>*</span>
          {label?.fdaLabelFootNote}
        </div>
      </WrapperFactsPanel>
    </div>
  );
}

export default VerticalLabelWithMicronutrient;
